import { Link } from 'react-router-dom';

export function RelatedLinks({ title = '相关推荐', links }) {
  return (
    <div className="bg-white/5 rounded-2xl border border-purple-500/20 p-6">
      <h3 className="font-semibold text-secondary mb-4">{title}</h3>
      <ul className="space-y-3">
        {links.map((link) => (
          <li key={link.to + link.label}>
            <Link
              to={link.to}
              className="flex items-center justify-between text-purple-200 text-sm hover:text-secondary transition-colors group"
            >
              <span>{link.label}</span>
              <i className="fa fa-arrow-right text-xs opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
